/**
 * The popup box used by the Search Results map widget
 *
 * This directly extends from the InfoBox library in the CDN
 * @param {Object} options Any custom options to add to the info box
 */
function SearchMapInfoBox(options) {
    InfoBox.call(this, $.extend({
        disableAutoPan: false,
        maxWidth: 0,
        pixelOffset: new google.maps.Size(-130, -313),
        zIndex: null,
        boxClass: "info-box",
        closeBoxMargin: "6px",
        closeBoxURL: "/images/close.gif",
        infoBoxClearance: new google.maps.Size(5, 46),
        isHidden: false,
        pane: "floatPane",
        enableEventPropagation: false
    }, options));
}

if(typeof InfoBox === undefined) {
    console.error("InfoBox library was not found");
}

//Extend the Google Maps marker
SearchMapInfoBox.prototype = Object.create(InfoBox.prototype);
SearchMapInfoBox.prototype.constructor = InfoBox;

window.SearchMapInfoBox = SearchMapInfoBox;



//////////////////
// WEBPACK FOOTER
// ./src/js/searchResults/SearchMapInfoBox.js
// module id = 8
// module chunks = 0